<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    (click)="dismissModal()"
                    alt="Close"
                    title="Close"
                    aria-hidden="true">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <i
                    class="nlrp-icon nlrp-icon-user nlrp-48"
                    style="color:#a6bd38"></i>
                <h3
                    class="modal-title"
                    style="display:inline-block"
                    >{{title}}</h3
                >
            </div>
            <div class="modal-header">
                <h5>{{plan}}</h5>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="col-xs-6">
                                <label class="control-label">Currently assigned to</label>
                                <br />
                                <div class="input-group">
                                    <strong>{{currentAssignee}}</strong>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <label class="control-label">Re-assign to</label>
                                <div
                                    class="input-group"
                                    ng-class="{'has-error': fieldRecordAddressForm.locality.$invalid
                            && (fieldRecordAddressForm.locality.$dirty || fieldRecordAddressForm.$submitted)}">
                                    <ng-select
                                        class="nlr-ng-select"
                                        #assignTo="ngModel"
                                        [searchable]="false"
                                        [clearable]="false"
                                        name="assignTo"
                                        id="assignTo"
                                        placeholder="Select"
                                        bindLabel="givenName"
                                        [items]="users"
                                        [(ngModel)]="assignedTo"
                                        (change)="userChanged($event)">
                                        <ng-template
                                            ng-option-tmp
                                            let-item="item">
                                            {{item.givenName}} {{item.surname}}
                                        </ng-template>
                                        <ng-template
                                            ng-label-tmp
                                            let-item="item">
                                            {{item.givenName}} {{item.surname}}
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <span class="inline-buttons">
                    <button
                        type="button"
                        id="assignUserBtn"
                        class="btn btn-default nlr-btn-sm"
                        title="Assign User to Plan"
                        (click)="assign()"
                        ng-click="assignUserModalController.assign()"
                        >Save
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                </span>
                <span class="inline-buttons">
                    <p>
                        <button
                            type="button"
                            id="cancelUserBtn"
                            class="btn btn-warning nlr-btn-sm"
                            title="Close the assign user screen without saving"
                            (click)="dismissModal()"
                            >Cancel</button
                        ></p
                    >
                </span>
            </div>
        </div>
    </div>
</div>
